import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import theme from './styles/theme';

import GlobalStyles from './styles/global.styles';
import store from './store';
import Routes from './Routes';
import Env from './config/env';

ReactGA.initialize(Env.TRACKING_ID);
ReactDOM.render(
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <GlobalStyles />
      <Routes />
    </Provider>
  </ThemeProvider>,
  document.getElementById('root'),
);
